'use client'

import { Button } from '@/components/ui/button'

export const CALENDLY_URL = 'https://calendly.com/infiteq/30min'

type CalendlyWindow = Window & {
  Calendly?: { initPopupWidget: (opts: { url: string }) => void }
}

export function openCalendly() {
  if (typeof window === 'undefined') return
  const w = window as CalendlyWindow
  if (w.Calendly) {
    w.Calendly.initPopupWidget({ url: CALENDLY_URL })
    return
  }
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = 'https://assets.calendly.com/assets/external/widget.css'
  document.head.appendChild(link)
  const script = document.createElement('script')
  script.src = 'https://assets.calendly.com/assets/external/widget.js'
  script.onload = () => (window as CalendlyWindow).Calendly?.initPopupWidget({ url: CALENDLY_URL })
  document.head.appendChild(script)
}

export function CalendlyButton({ children, size = 'lg', variant = 'outline' }: {
  children: React.ReactNode
  size?: 'lg' | 'sm' | 'md'
  variant?: 'outline' | 'primary'
}) {
  return (
    <Button size={size} variant={variant} onClick={openCalendly}>
      {children}
    </Button>
  )
}
